import { SharedConstants } from "../../../shared/constants/shared.constants";
export const CANCEL_TEXT = SharedConstants.CANCEL_LABEL;
export const SEND_TEXT = SharedConstants.SEND_LABEL;
export const TITLE_TEXT = "Esri feedback";
export const OBJECT_NAME = "Email feedback";
